<template>
  <v-container>
    <!-- Centra el saludo y la frase inspiradora -->
    <v-row justify="center">
      <v-progress-circular v-if="loadinguserDetails" color="primary" indeterminate></v-progress-circular>
      <v-col v-if="!loadinguserDetails" cols="12" class="text-center">
        <h1 class="mb-3">{{ t('Hola') }} {{ nick }}</h1>
        <div v-if="inspirationalQuote" class="font-italic">{{ inspirationalQuote }}</div>
      </v-col>
    </v-row>

    <!-- Ajusta los componentes a la mitad del ancho cada uno -->
    <v-row>
      <v-col cols="12">
        <v-card>
          <v-toolbar>
            <v-toolbar-title>{{ t('Tus_reservas') }}</v-toolbar-title>

            <v-btn icon :to="`/reservas`">
              <v-icon>mdi-calendar-month</v-icon>
            </v-btn>
          </v-toolbar>
          <ReservationList></ReservationList>
        </v-card>
      </v-col>
    </v-row>

    <!-- Coloca el texto de exploración de actividades abajo -->
    <TotesActivitats></TotesActivitats>
  </v-container>
</template>

<script setup>
import { ref, onMounted, computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { useUserStore } from '@/stores/user';
import ReservationList from './ReservationList.vue';
import TotesActivitats from './TotesActivitats.vue';

const userStore = useUserStore();
const { t } = useI18n();

// Variables reactivas
const inspirationalQuote = ref('');
const loadinguserDetails = computed(() => userStore.loadingUserDetails);
const nick               = computed(() => userStore.userDetails?.nickname ?? null);

// Función para obtener la cita inspiradora
const getInspirationalQuote = async () => {
  try {
    const response = await fetch(`api/get-quote/`);
    const data = await response.json();
    inspirationalQuote.value = data.quote;
  } catch (error) {
    console.error('Error obteniendo la cita:', error);
  } 
};

// Llamar a las funciones cuando el componente se monta
onMounted(() => {
  getInspirationalQuote();
});
</script>